import { useState } from 'react'
import { ScanQrCode } from 'lucide-react'

import { GrowerAreaQRDialog } from './grower-area-qr-dialog'
import type { GrowerAreaQRItem } from './grower-area-qr-dialog'
import type { GrowerAreaQrEntry } from '@/lib/grower-area-qr-tracking'
import { Button } from '@/components/ui/button'
import { m } from '@/lib/paraglide/messages'

type Props = {
    /** Vùng trồng của hộ. `undefined` = chưa biết (đang tải hoặc lỗi). */
    areas: GrowerAreaQRItem[] | undefined
    growerName?: string | null
    /** Số điện thoại của hộ — nửa đầu nội dung mã QR, không phải trang trí. */
    growerPhone?: string | null
    loading?: boolean
    error?: boolean
    onRetry?: () => void
    /** Màn nào đang mở popup — bắt buộc, xem `GrowerAreaQRDialogProps.entry`. */
    entry: GrowerAreaQrEntry
}

/**
 * Nút "QR vùng trồng" cho các màn ĐÃ có sẵn hồ sơ hộ (màn chi tiết hộ của nhân
 * viên, màn hộ tự xem). Việc chọn vùng nằm trong popup dùng chung, nên nút này
 * chỉ lo mở popup.
 *
 * Cố ý KHÔNG ẩn nút khi hộ chưa có vùng: popup là chỗ duy nhất nói được vì sao
 * chưa có QR ("chưa khai vùng" khác "vùng chưa lưu" khác "hỏng mạng"), còn nút
 * biến mất thì người dùng chỉ thấy tính năng lúc có lúc không.
 */
export function GrowerAreaQRTrigger({
    areas,
    growerName,
    growerPhone,
    loading,
    error,
    onRetry,
    entry,
}: Props) {
    const [open, setOpen] = useState(false)

    return (
        <>
            <Button
                type="button"
                variant="outline"
                size="icon"
                className="shrink-0"
                onClick={() => setOpen(true)}
                title={m.grower_area_qr_button()}
                aria-label={m.grower_area_qr_button()}
            >
                <ScanQrCode className="size-4" />
            </Button>

            <GrowerAreaQRDialog
                open={open}
                onOpenChange={setOpen}
                areas={areas}
                growerName={growerName}
                growerPhone={growerPhone}
                loading={loading}
                error={error}
                onRetry={onRetry}
                entry={entry}
            />
        </>
    )
}
